import { Button, Typography } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import ModalV2 from '/@/components/bayer/modal-v2';
import { _ } from '/@/locale';
import { useDeleteRecommendationMutation } from '/@/store/private-data/recommendations/apiProviders';

const DeleteRecommendationModal = ({
    recommendationId,
    onSuccess,
    open,
    setOpen,
}: {
    recommendationId: number;
    onSuccess: () => void;
    open: boolean;
    setOpen: (open: boolean) => void;
}) => {
    const deleteFieldMutation = useDeleteRecommendationMutation();
    const handleDeleteRecommendation = async () => {
        try {
            await deleteFieldMutation.trigger({ id: recommendationId });
            onSuccess();
            setOpen(false);
            enqueueSnackbar(_('Recomendación eliminada correctamente'), {
                variant: 'success',
                SnackbarProps: {
                    'data-testid': 'delete-recommendation-modal-success-message',
                },
            });
        } catch (error) {
            enqueueSnackbar(_('Error al eliminar la recomendación'), {
                variant: 'error',
            });
        }
    };

    return (
        <ModalV2
            open={open}
            setOpen={setOpen}
            title={_('Eliminar recomendación')}
            data-testid='delete-recommendation-modal'
            description={_('¿Estás seguro que querés eliminar esta recomendación?')}
            actions={
                <>
                    <Button
                        variant='text'
                        color='secondary'
                        onClick={(e) => {
                            e.stopPropagation();
                            handleDeleteRecommendation();
                        }}
                        loading={deleteFieldMutation.isMutating}
                        disabled={deleteFieldMutation.isMutating}
                        data-testid='delete-recommendation-modal-delete-button'
                    >
                        {_('Eliminar')}
                    </Button>
                    <Button
                        variant='contained'
                        color='primary'
                        onClick={(e) => {
                            e.stopPropagation();
                            setOpen(false);
                        }}
                        disabled={deleteFieldMutation.isMutating}
                    >
                        {_('Cancelar')}
                    </Button>
                </>
            }
            actionsProps={{
                justifyContent: 'end',
            }}
        >
            <Typography variant='body1' color='primary'>
                {_('Una vez eliminada la recomendación, no podrás recuperarla.')}
            </Typography>
        </ModalV2>
    );
};

export default DeleteRecommendationModal;
